import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BuildingOpeningDay } from '../../models';

import { ApiService } from '../../utils/api.service';

@Injectable()
export class BuildingOpeningDayService {

  path = 'building_opening_days';
  constructor(
    private apiService: ApiService,
  ) {
  }

  setIsOpen(openingDay: BuildingOpeningDay, isOpen: boolean): Observable<BuildingOpeningDay> {
    const body = {
      isOpen,
    };

    return this.apiService.put(this.path + '/' + openingDay.id, body);
  }
}
